import React from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from '../../Units/Avatar';

const ClubDataRow = ({ data, avatar }) => {
    const { t } = useTranslation();
    return (
        <li className="clubRow">
            <div className="avatarContent">
                <Avatar data={avatar} />
            </div>
            <div className="clubRowInfo">
                <div className="clubRowName">{data.username}</div>
                <div className="clubRowId">{`Club ID: ${data._id || data.accountId}`}</div>
            </div>
            <div className="clubStats">
                <header className="clubStatsHeader">{t('pokerWinLossFee')}</header>
                <ul className="clubStatsRow">
                    <li className="clubStat">
                        <header className="clubStatHeader">{t('pokerWinLossFeeOverall')}</header>
                        <p className="clubStatValue">{data.stats.overall}</p>
                    </li>
                    <li className="clubStat">
                        <header className="clubStatHeader">{t('pokerWinLossFeeLastWeek')}</header>
                        <p className="clubStatValue">{data.stats.lastWeek}</p>
                    </li>
                    <li className="clubStat">
                        <header className="clubStatHeader">{t('pokerWinLossFeeThisWeek')}</header>
                        <p className="clubStatValue">{data.stats.thisWeek}</p>
                    </li>
                </ul>
            </div>
        </li>
    );
};

export default ClubDataRow;
